import React from 'react'
import { LuFileText } from 'react-icons/lu'

// Document tile shown left of a trivvy name. Reuses FolderRow's
// `.folder-row-icon-wrap` geometry so both tiles land in one column.
const ListRowIcon = () => {
  return (
    <div className="folder-row-icon-wrap trivvy-row-icon-wrap">
      <LuFileText className="folder-row-icon trivvy-row-icon" />
    </div>
  )
}

export default ListRowIcon
